import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Async from 'components/Async';
import store from 'store';
import clearApiCacheAndReloadSW from 'utils/serviceWorkerCleanup';

import { verifyEmail } from '@common/api/auth';
import { Role } from '@common/components/RBAC';
import { getRoute } from '@common/constants/CampusRoutes';

function ImpersonatePage() {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	useEffect(() => {
		const token = searchParams.get('token');
		const loginBy = searchParams.get('login_by') as Role;
		const emailVerification = searchParams.get('verifyEmail');

		if (!token) {
			navigate(getRoute(['NEWS']));
		}

		const handleLogin = async () => {
			if (!token) return;
			await clearApiCacheAndReloadSW();
			store.auth.logout();
			await store.auth._login({ token }, true);

			if (emailVerification === 'true') {
				try {
					await verifyEmail();
				} catch (error) {
					console.error('Error verification email:', error);
				}
			}

			if (loginBy) {
				store.auth.setImpersonateRole(loginBy);

				// Select Lyceum for mentors
				if (loginBy === 'Mentor/Tutor') {
					store.services.select(2);
				}

				// Select TIS for Auditor, Teacher
				if (loginBy === 'Auditor' || loginBy === 'Teacher') {
					store.services.select(3);
				}
			}

			navigate(getRoute(['NEWS']));
		};

		handleLogin();
	}, [searchParams]);

	return <Async loading />;
}

export default observer(ImpersonatePage);
